(function() {
	'use strict';

	angular
		.module('app.setup')
		.service('projectTemplatesService', projectTemplatesService);

	projectTemplatesService.$inject = ['$http', 'URLS'];

	function projectTemplatesService($http, URLS) {
		var url = URLS.host + URLS.prefix + '{0}/LeanProject';
		var service = {
			getProjectTemplate: getProjectTemplate,
			getProjectTemplates: getProjectTemplates,
			addTemplate: addTemplate,
			updateTemplateField: updateTemplateField,
			deleteTemplate: deleteTemplate,
			saveTemplateTask: saveTemplateTask,
			deleteTemplateTask: deleteTemplateTask,
			getTemplateTaskGroups: getTemplateTaskGroups,
			getProjectTemplateDefault: getProjectTemplateDefault,
			saveProjectTemplateDefault: saveProjectTemplateDefault
		};
		return service;

		function getProjectTemplate(templateNdx, siteId) {
			return $http.get(String.format(url, siteId || globalConfig.factory.id) + '/ProjectTemplate/' + templateNdx)
				.then(getProjectTemplateSuccess, handleError);

			function getProjectTemplateSuccess(response) {
				return response;
			}
		}
		
		function getProjectTemplates(siteId) {
			return $http.get(String.format(url, siteId || globalConfig.factory.id) + '/ProjectTemplates')
				.then(getProjectTemplatesSuccess, handleError);

			function getProjectTemplatesSuccess(response) {
				return response;
			}
		}
		
		function addTemplate(template, siteId) {
			return $http.post(String.format(url, siteId || globalConfig.factory.id) + '/ProjectTemplates', template)
				.then(addTemplateSuccess, handleError);

			function addTemplateSuccess(response) {
				return 'Project template created successfully';
			}
		}
		
		function updateTemplateField(template, lastModified, siteId) {			
			return $http.put(String.format(url, siteId || globalConfig.factory.id) + '/ProjectTemplates', template, {headers: {'If-Unmodified-Since': lastModified}})
				.then(updateTemplateFieldSuccess, handleError);

			function updateTemplateFieldSuccess(response) {
				return response;
			}
		}
		
		function deleteTemplate(templateNdx, siteId) {
			return $http.delete(String.format(url, siteId || globalConfig.factory.id) + '/ProjectTemplates/' + templateNdx)
			.then(deleteTemplateSuccess, handleError);

			function deleteTemplateSuccess(response) {
				return 'Project template deleted successfully';
			}	
		}
		
		function saveTemplateTask(templateNdx, task, siteId) {
			return $http.put(String.format(url, siteId || globalConfig.factory.id) + '/ProjectTemplate/' + templateNdx + '/Task', task)
			.then(saveTemplateTaskSuccess, handleError);

			function saveTemplateTaskSuccess(response) {
				return 'Template task saved successfully';
			}
		}
		
		function deleteTemplateTask(templateNdx, taskNdx, siteId) {
			return $http.delete(String.format(url, siteId || globalConfig.factory.id) + '/ProjectTemplate/' + templateNdx + '/Task/' + taskNdx)
			.then(deleteTemplateTaskSuccess, handleError);

			function deleteTemplateTaskSuccess(response) {
				return 'Template task deleted successfully';
			}	
		}

		function getTemplateTaskGroups(templateNdx, leanDirFactoryNdx) {
			var url = URLS.host + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/ProjectTemplate/' + templateNdx + '/TaskGroups';
			return $http.get(url)
				.then(getTemplateTasksGroupsSuccess)
				.catch(handleError);

			function getTemplateTasksGroupsSuccess(response) {
				return response.data || [];
			}
		}

		function getProjectTemplateDefault(siteId) {
			return $http.get(String.format(url, siteId || globalConfig.factory.id) + '/ProjectTemplate/Default')
				.then(getProjectTemplatesSuccess, handleError);

			function getProjectTemplatesSuccess(response) {
				return response;
			}
		}

		function saveProjectTemplateDefault(templateNdx, siteId) {
			var templateDefault = { templateNdx: templateNdx };
			return $http.put(String.format(url, siteId || globalConfig.factory.id) + '/ProjectTemplate/Default', templateDefault)
				.then(saveTemplateDefaultSuccess, handleError);

			function saveTemplateDefaultSuccess(response) {
				return response;
			}
		}
		
		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 412) {
				return error.data.error;
			}
			return 'Unknown server error';
		}
	}
})();
